import {
  GET_PRODUCT_DATA,
  GET_PRODUCT_DATA_BY_ID,
  RESET_REDUX_STATE,
  RESET_SINGLE_PRODUCT_DATA,
  GET_ALL_PRODUCT_DATA,
  PRODUCT_INVENTORY_BY_PRODUCT_ID,
  CLEAR_PRODUCT_INVENTORY_BY_PRODUCT_ID
} from "../constants";

const initialValues = {
  productData: "",
  singleProduct: "",
  allProductData: [],
  inventoryProductsAvailable: []
};

const productMaster = (state = initialValues, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_PRODUCT_DATA: {
      return {
        ...state,
        productData: payload,
      };
    }

    case GET_ALL_PRODUCT_DATA: {
      return {
        ...state,
        allProductData: payload,
      };
    }

    case RESET_REDUX_STATE: {
      return initialValues;
    }

    case GET_PRODUCT_DATA_BY_ID: {
      return {
        ...state,
        singleProduct: payload,
      };
    }

    case PRODUCT_INVENTORY_BY_PRODUCT_ID: {
      return {
        ...state,
        inventoryProductsAvailable: [...state.inventoryProductsAvailable, payload]
      }
    }

    case RESET_SINGLE_PRODUCT_DATA: {
      return {
        ...state,
        singleProduct: "",
      };
    }

    default: {
      return state;
    }
  }
};

export default productMaster;
